// FNP-969 — the console's ONLY write to a TestObservation, and it is a DELETE.
//
// ═══ THE MODULE REMAINS APPEND-ONLY ═══
//
// Delete is not an edit affordance and does not soften the append-only rule. An
// observation is EVIDENCE: it records what a synthetic user did and what the
// platform did back. You may discard the whole record; you may never rewrite what
// it says. There is deliberately no updateTestObservation here and there must
// never be one — an editable observation is an unreliable witness, and the defect
// signatures folded from these rows would inherit that unreliability.
//
// ═══ WHY THIS EXISTS AT ALL ═══
//
// FNP-861 left this module read-only on the stated grounds that "the executor owns
// the TestObservation lifecycle". The executor never did: `deleteTestObservation`
// appears ONLY in comments across src/canary, src/tick and src/triage in
// flexinet-testing-api — there is no call site. So the capability was reachable
// from nowhere, and clearing observations from an environment required a direct
// DynamoDB script, breaking the platform's "no direct table writes" rule to do
// something entirely legitimate.
//
// The mutation returns `ID` (the deleted id), not the row — there is no row left
// to return.
export const deleteTestObservation = `
   mutation deleteTestObservation($id: ID!) {
       deleteTestObservation(id: $id)
   }
`;
